<template>
  <div class="slider-tours">
    <div class="slider-tours__top">
      <div v-if="!!$slots.title" class="slider-tours__title">
        <slot name="title" />
      </div>
      <div class="slider-tours__navigation u-flex-shrink-0">
        <button
          ref="prev"
          type="button"
          class="slider-tours__navigation-button _prev u-clickable"
        >
          <svg-inline tag="span" class="u-decor u-stroke-deep-current">
            <icon icon="dropdown" />
          </svg-inline>
        </button>
        <button
          ref="next"
          type="button"
          class="slider-tours__navigation-button _next u-clickable"
        >
          <svg-inline tag="span" class="u-decor u-stroke-deep-current">
            <icon icon="dropdown" />
          </svg-inline>
        </button>
      </div>
    </div>
    <div class="slider-tours__slider">
      <div ref="swiper" class="slider-tours__swiper swiper">
        <div class="swiper-wrapper">
          <div
            v-for="tour in tours"
            :key="tour.id"
            class="slider-tours__slide swiper-slide"
          >
            <tour-card :tour="tour" class="slider-tours__card" :query="{}" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation } from "swiper";
import "swiper/swiper.scss";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import TourCard from "@/components/ui-kit/tour-card/index.vue";

export default {
  components: {
    SvgInline,
    Icon,
    TourCard,
  },
  props: {
    tours: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      swiperInstance: null,
    };
  },
  mounted() {
    this.$nextTick(this.initSlider);
  },
  beforeDestroy() {
    this.destroySlider();
  },
  methods: {
    initSlider() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        touchReleaseOnEdges: true,
        observer: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
        },
        modules: [Navigation],
      });
    },
    destroySlider() {
      this.swiperInstance?.destroy();
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-tours {
  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 32px;

    @include mixin.size-lg-min {
      margin-bottom: 40px;
    }
  }

  &__title {
    @include mixin.size-lg-min {
      margin-right: 20px;
    }
  }

  &__navigation {
    display: none;
    align-items: center;

    @include mixin.size-lg-min {
      display: flex;
    }

    &-button {
      @include mixin.button-reset();
      width: 28px;
      padding: 3px 0 0 0;
      background: var.$white;
      border-radius: 50%;
      transition: var.$transition-default;
      box-shadow: -2px 1px 28px 0px rgba(153, 153, 169, 0.30);
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:not(:last-child) {
        margin-right: 8px;
      }

      &._prev {
        transform: rotate(90deg);
      }

      &._next {
        transform: rotate(-90deg);
      }

      &.swiper-button-disabled {
        opacity: 0.5;
      }

      & >>> span {
        height: 16px;
        width: 16px;
      }
    }
  }

  &__slider {
    margin: 0 -8px;

    @include mixin.size-md-min {
      margin: 0 -12px;
    }

    @include mixin.size-lg-min {
      margin: 0 -16px;
    }
  }

  &__swiper {
    overflow: visible;
  }

  &__slide {
    width: auto;
    height: auto;
    display: flex;
  }

  &__card {
    width: 328px;
    margin: 0 8px;

    @include mixin.size-md-min {
      margin: 0 12px;
    }

    @include mixin.size-lg-min {
      width: 292px;
      margin: 0 16px;
    }
  }
}
</style>
